import { createContext, useContext } from "react";

export const PatientConsultationContext = createContext({
    steps(num) { },
    consultDetails: {},
    setConsultDetails(doc) { },
    async bookAppointment() { },
    async futureRDVCheck() { },
    async newPatientInsertBook(data) { },
    refresh() { }
})

export const useConsultationContext = () => useContext(PatientConsultationContext)